<template>
	<div class="">
		<el-dialog title="" @close="close" :visible.sync="currentVideoShow" :close-on-click-modal="false" width="70%" center>
			<div class="flex justify-between">
				<div class="w-[100%]  h-[500px] relative">
					<!-- <img @click.stop="downLoad()" src="@/static/image/icon57.png" class="absolute cursor-pointer"
						style="width: 36px;height: 36px;z-index: 99;top:16px;right: 16px;" alt="" srcset="" /> -->
					<VideoPlayer v-if="currentVideoShow" :videoUrl="video_url" :seekTime="view_duration"
						:trialDuration="trialDuration" @purchase="purchase" @videoClose="videoClose" />
				</div>
				<!--<div class="flex-1 h-[500px]" style="overflow-y: scroll;" v-if="visible&&videoList.length>0">
					 <div @click="selectChapter(item,index)" :class="currentPlayValue==index?'text-[#2979FF]':''"
						class="bg-[#f3f3f3] cursor-pointer rounded-[4px] mb-[14px] yw-text-cut-1 h-[48px] leading-[48px] px-[18px] box-border"
						v-for="(item,index) in videoList" :key="index">
						{{item.chapter_name}}
					</div> 
				</div>-->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { saveAs } from 'file-saver';
	import VideoPlayer from './VideoPlayer.vue';
	export default {
		components: {
			VideoPlayer
		},
		props: {
			isVideoVisible: {
				type: Boolean,
				default: false,
			}, // 视频
			
			allVideoList:{
				type: Array,
				default: [],
			},
			videoSrc: {
				type: String,
				default: '',
			}, // 视频路径
			trialDuration: {
				type: [String, Number],
				default: 0,
			}, // 试看时间

			seekTime: {
				type: [String, Number],
				default: 0,
			}, // 上次观看时间

			currentVideo: {
				type: [String, Number],
				default: -1,
			},
			order_item_id: {
				type: [String, Number],
				default: 0,
			},
			subject_id: {
				type: [String, Number],
				default: 0,
			},
			selectChapterIndex: {
				type: [String, Number],
				default: 0,
			},
			current_video_id:{
				type: [String, Number],
				default: 0,
			}
		},
		watch: {
			// 监视message属性的变化
			isVideoVisible: function(newVal, oldVal) {
				console.log('isVideoVisible changed from', oldVal, 'to', newVal);
				this.visible = newVal
				console.log("current_video_id===" + this.current_video_id);

				if (this.visible) {
					console.log("this.currentVideo===" + this.currentVideo);
					this.currentPlayValue = this.currentVideo
					this.beforePlayValue = this.currentPlayValue
					if (this.currentPlayValue > -1) {
						if (this.subject_id > 0) {
							this.get_subject_chapter_list()
						}
console.log("this.order_item_id====0=="+this.order_item_id);
						if (this.order_item_id > 0) {
							this.get_video_info()
							// this.getChapterList()
						}
					}
				}

			},
			currentVideo: function(newVal, oldVal) {
				console.log('currentVideo changed from', oldVal, 'to', newVal);
				this.currentPlayValue = newVal
				this.beforePlayValue = this.currentPlayValue
				
				
				console.log("current_video_id===" + this.current_video_id);
				
				if (this.currentPlayValue > -1) {
					console.log("this.id==" + this.order_item_id);
					console.log("this.subject_id==" + this.subject_id);
					if (this.subject_id > 0) {
						this.get_subject_chapter_list()
					}
console.log("this.order_item_id====0=="+this.order_item_id);
					if (this.order_item_id > 0) {
						this.get_video_info()
						// this.getChapterList()
					}
				}
			}
		},
		data() {
			return {
				visible: false,
				currentVideoShow: false,
				currentPlayValue: -1,
				beforePlayValue: -1,
				view_duration: 0,
				videoInfo: {
					id: '',
					video_url: '',
					file_size: 120, //试看时间
					view_duration: 0, //上次观看时间
				},
				
				changeType: '',
				chapterList: [],
				videoList: [],
				video_url: '',

			}
		},
		mounted() {

		},
		methods: {
			downLoad() {
				window.open('https://app.51exampass.comapi/v1.index/videoToStream?server=1&id=' + this.videoInfo.id,'_blank')
			},
			get_subject_chapter_list() {
				this.$api.subject_detail({
					id: this.subject_id
				}).then((res) => {
					console.log(res);
					this.chapterList = res.data.small_list


					this.videoList = this.chapterList[this.selectChapterIndex].class
					if (this.videoList.length > 0) {
						this.getSubjectChapterInfo()
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getSubjectChapterInfo() {
				this.videoInfo = this.videoList[this.currentPlayValue].video
				this.video_url = ""
				this.video_url = this.videoInfo.url
				this.$nextTick(() => {
					this.currentVideoShow = true
				})
			},
			get_video_info(){
				console.log("#23====");
				this.$api.getvideo_info({
					item_id: this.order_item_id,
					id:this.current_video_id
				}).then((res) => {
					console.log("res.data========");
					console.log(res.data);
					
					
					this.videoInfo = res.data.video_info
					let userVideo = res.data.userVideo
					this.video_url = ""
					this.video_url = this.videoInfo.video_url
					//  + '?rnd=' + new Date().getTime()
					if (userVideo) {
						this.view_duration = userVideo.view_duration
					}
					this.$nextTick(() => {
						this.currentVideoShow = true
					})
					
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getChapterList() {
				this.video_url="";
				
				
				var that = this;
				
				
				// this.videoList=this.allVideoList
				// if (this.videoList.length > 0) {
				// 	this.getVideoInfo()
				// }
				// return
				
				
				this.$api.order_chapter_class({
					item_id: this.order_item_id,
				}).then((res) => {
					console.log("res.data========");
					console.log(res.data);
					this.chapterList = res.data
					this.videoList = this.chapterList[this.selectChapterIndex].small_list_class
					if (this.videoList.length > 0) {
						this.getVideoInfo()
					}
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getVideoInfo() {
				this.videoInfo = this.videoList[this.currentPlayValue].video_info
				let userVideo = this.videoList[this.currentPlayValue].userVideo
				this.video_url = ""
				this.video_url = this.videoInfo.video_url
				//  + '?rnd=' + new Date().getTime()
				if (userVideo) {
					this.view_duration = userVideo.view_duration
				}
				this.$nextTick(() => {
					this.currentVideoShow = true
				})
			},
			// 解锁
			purchase() {
				console.log("解锁");
				this.$emit('purchase')
			},
			close() {
				this.visible = false
				console.log("关闭");
				this.changeType = ""
				this.video_url = ""

				console.log('===this.video_url===');
				console.log(this.video_url);

				this.currentVideoShow = false
				this.$emit('close')
			},
			videoClose(e) {


				console.log("3332323323");
				console.log("this.id===" + this.id);

				if (this.order_item_id > 0) {
					if (this.changeType == 'changeVideo') {
						// 如果是切换章节
						if (e.playTime > 0) {
							let view_duration = Math.round(e.playTime)
							if(this.videoList[this.beforePlayValue].video_info){
								let course_resource_id = this.videoList[this.beforePlayValue].video_info.id
								this.addUserVideoRecord(view_duration, course_resource_id)
							}else if(this.videoList[this.beforePlayValue].video){
								let course_resource_id = this.videoList[this.beforePlayValue].video.id
								this.addUserVideoRecord(view_duration, course_resource_id)
							}
						}
					} else {
						if (e.playTime > 0) {
							// 如果是直接关闭
							console.log("直接关闭this.currentPlayValue===" + this.currentPlayValue);
				
							console.log("this.videoList[this.currentPlayValue]==");
							console.log("this.videoInfo===");
							console.log(this.videoInfo);
						
							let view_duration = Math.round(e.playTime)
							
							if(this.videoInfo){
								let course_resource_id = this.videoInfo.id
								this.addUserVideoRecord(view_duration, course_resource_id)
							}else if(this.videoList[this.currentPlayValue].video){
								let course_resource_id = this.videoList[this.currentPlayValue].video.id;
								this.addUserVideoRecord(view_duration, course_resource_id)
							}
						}
					}
				}
			},
			addUserVideoRecord(view_duration, course_resource_id) {
				let is_finished = 1 // 是否看完:0=未看完,1=已看完
				if (view_duration < this.videoInfo.file_size) {
					is_finished = 0
				}
				this.changeType = ""
				console.log("====" + this.videoList[this.beforePlayValue]);
				let param = {
					course_resource_id: course_resource_id,
					view_duration: view_duration,
					is_finished: is_finished,
					last_view_time: Math.floor(new Date().getTime() / 1000), // 最后观看时间
					platform: 1, //1=官网,2=移动端
					order_item_id: this.order_item_id
				}
				console.log(param);
				this.$api.addUserVideoRecord(param).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			selectChapter(item, index) {
				this.beforePlayValue = this.currentPlayValue
				this.currentVideoShow = false
				this.currentPlayValue = index

				console.log('切换this.currentPlayValue===' + this.currentPlayValue);

				this.changeType = "changeVideo"
				if (this.id > 0) {
					this.getVideoInfo()
				}
				if (this.subject_id) {
					getSubjectChapterInfo()
				}
			}


		}
	}
</script>

<style scoped>
	::-webkit-scrollbar {
		display: none;
	}
</style>